{
  "site": {
    "title": "الموقع",
    "backToRegister": "العودة إلى المواقع",
    "archivedBanner": "هذا الموقع مؤرشف: تبقى أماكنه ومعداته محفوظة، ولا يمكن إضافة شيء إليه.",
    "archivedStamp": "مؤرشف",
    "flat": "قالب هذا الموقع بلا مستويات: معداته على الموقع نفسه.",
    "jumpToAssets": "الانتقال إلى المعدات ({{n}})"
  },
  "header": {
    "addPlaces": "إضافة أماكن",
    "generate": "إنشاء أماكن…",
    "addOne": "إضافة مكان",
    "import": "استيراد CSV…",
    "edit": "تعديل",
    "newJob": "أمر خدمة جديد في هذا الموقع",
    "archiveSite": "أرشفة الموقع",
    "restoreSite": "استعادة الموقع",
    "levelCount": "{{level}}: {{n}}",
    "places_zero": "لا أماكن",
    "places_one": "مكان واحد",
    "places_two": "مكانان",
    "places_few": "{{n}} أماكن",
    "places_many": "{{n}} مكاناً",
    "places_other": "{{n}} مكان",
    "assets_zero": "لا معدات",
    "assets_one": "معدّة واحدة",
    "assets_two": "معدّتان",
    "assets_few": "{{n}} معدّات",
    "assets_many": "{{n}} معدّة",
    "assets_other": "{{n}} معدّة",
    "issues_zero": "لا أعطال",
    "issues_one": "معدّة واحدة معطلة",
    "issues_two": "معدّتان معطلتان",
    "issues_few": "{{n}} معدّات معطلة",
    "issues_many": "{{n}} معدّة معطلة",
    "issues_other": "{{n}} معدّة معطلة",
    "countsHint": "تُحسب المعدات العاملة والمعطلة؛ وتبقى المزالة والمستبدلة في سجلها."
  },
  "empty": {
    "title": "لا أماكن في هذا الموقع بعد",
    "body": "أنشئ الطوابق والوحدات دفعة واحدة، أو استوردها مع معداتها من ملف CSV.",
    "readOnly": "يضيف الأماكنَ من يديرون المواقع والمعدات.",
    "onSite": "ضع المعدات على الموقع نفسه (فيلا أو محل)"
  },
  "off": {
    "title": "سجل المعدات متوقف",
    "body": "المواقع وأماكنها ومعداتها محفوظة لكنها لا تظهر. يمكن للمسؤول إعادة تشغيل السجل من الإعدادات › أوامر الخدمة.",
    "configBody": "هذه محفوظة، ولن تُستخدم حتى يُعاد تشغيل السجل.",
    "settings": "فتح إعدادات الخدمة"
  },
  "tree": {
    "label": "أماكن {{name}}",
    "search": "البحث في الأماكن",
    "clearSearch": "مسح البحث",
    "showArchived": "إظهار الأماكن المؤرشفة",
    "archived": "مؤرشف",
    "allFine": "كلها في الخدمة",
    "noAssets": "لا معدات",
    "issues_zero": "لا معدات معطلة",
    "issues_one": "معدّة واحدة معطلة",
    "issues_two": "معدّتان معطلتان",
    "issues_few": "{{n}} معدّات معطلة",
    "issues_many": "{{n}} معدّة معطلة",
    "issues_other": "{{n}} معدّة معطلة",
    "assets_zero": "لا معدات",
    "assets_one": "معدّة واحدة",
    "assets_two": "معدّتان",
    "assets_few": "{{n}} معدّات",
    "assets_many": "{{n}} معدّة",
    "assets_other": "{{n}} معدّة",
    "matches_zero": "لم يُعثر على أي مكان",
    "matches_one": "عُثر على مكان واحد",
    "matches_two": "عُثر على مكانين",
    "matches_few": "عُثر على {{n}} أماكن",
    "matches_many": "عُثر على {{n}} مكاناً",
    "matches_other": "عُثر على {{n}} مكان",
    "noMatches": "لا يطابق البحثَ أيُّ مكان.",
    "phoneLabel": "الأماكن",
    "backTo": "العودة إلى {{name}}",
    "placesIn": "الأماكن في {{name}}",
    "placesOnSite": "أماكن الموقع",
    "matchesCut": "عُثر على {{n}} مكان: تظهر أول {{shown}} منها. اكتب المزيد لتضييق القائمة."
  },
  "panel": {
    "siteItself": "بيانات الموقع",
    "placeWord": "المكان",
    "wilayat": "المحافظة والولاية",
    "openMap": "فتح في الخرائط",
    "assetsHere_zero": "لا معدات هنا وفيما تحته",
    "assetsHere_one": "معدّة واحدة هنا وفيما تحته، عاملة أو معطلة",
    "assetsHere_two": "معدّتان هنا وفيما تحته، عاملتان أو معطلتان",
    "assetsHere_few": "{{n}} معدّات هنا وفيما تحته، عاملة أو معطلة",
    "assetsHere_many": "{{n}} معدّة هنا وفيما تحته، عاملة أو معطلة",
    "assetsHere_other": "{{n}} معدّة هنا وفيما تحته، عاملة أو معطلة",
    "addLevel": "إضافة {{level}}",
    "addPlace": "إضافة مكان",
    "edit": "تعديل",
    "move": "نقل",
    "duplicate": "تكرار",
    "archive": "أرشفة",
    "restore": "استعادة",
    "details": "التفاصيل",
    "occupant": "الساكن",
    "accessNotes": "ملاحظات الدخول",
    "more": "إجراءات أخرى لـ {{name}}"
  },
  "place": {
    "addTitle": "إضافة مكان",
    "addLevelTitle": "إضافة {{level}}",
    "editTitle": "تعديل {{name}}",
    "under": "ضمن {{name}}",
    "underSite": "في المستوى الأعلى من الموقع",
    "name": "الاسم",
    "nameHint": "كما يُعرف في الموقع: «12» أو «1204» أو «الردهة» أو «غرفة المعدات على السطح».",
    "nameAr": "الاسم بالعربية",
    "occupantHint": "من يسكن المكان أو يعمل فيه، لتسهيل الدخول. لا يظهر في تقارير الزيارات، ويراه فقط من يدير المواقع.",
    "occupantName": "اسم الساكن",
    "occupantPhone": "هاتف الساكن",
    "accessHint": "مثلاً: المفتاح عند الحارس، الاتصال قبل 30 دقيقة.",
    "add": "إضافة المكان",
    "save": "حفظ المكان",
    "added": "أُضيف {{name}}",
    "saved": "حُفظ {{name}}",
    "errors": {
      "name": "أدخل اسم المكان",
      "nameTaken": "يوجد مكان بجانبه بهذا الاسم",
      "tooLong": "النص طويل: اختصره.",
      "check": "راجع هذه القيمة.",
      "siteArchived": "هذا الموقع مؤرشف: استعده لتعديل أماكنه."
    }
  },
  "move": {
    "title": "نقل {{name}}",
    "body": "يُنقل المكان مع كل ما تحته، داخل هذا الموقع.",
    "to": "نقله إلى",
    "topLevel": "المستوى الأعلى من الموقع",
    "nowhere": "لا يوجد مكان آخر يمكن نقله إليه: مستويات القالب لا تتسع.",
    "confirm": "نقل المكان",
    "done": "نُقل {{name}}",
    "toHint": "ابحث بمسار المكان. امسحه لنقل المكان إلى المستوى الأعلى في الموقع."
  },
  "archive": {
    "title": "أرشفة {{name}}؟",
    "body": "يخرج المكان من الشجرة ومن نماذج أوامر الخدمة. يجب نقل المعدات العاملة فيه أو إزالتها أولاً.",
    "bodyBelow_zero": "يخرج المكان من الشجرة ومن نماذج أوامر الخدمة. يجب نقل المعدات العاملة فيه أو إزالتها أولاً.",
    "bodyBelow_one": "يخرج المكان والمكان الذي تحته من الشجرة ومن نماذج أوامر الخدمة. يجب نقل المعدات العاملة فيهما أو إزالتها أولاً.",
    "bodyBelow_two": "يخرج المكان والمكانان اللذان تحته من الشجرة ومن نماذج أوامر الخدمة. يجب نقل المعدات العاملة فيها أو إزالتها أولاً.",
    "bodyBelow_few": "يخرج المكان و{{n}} أماكن تحته من الشجرة ومن نماذج أوامر الخدمة. يجب نقل المعدات العاملة فيها أو إزالتها أولاً.",
    "bodyBelow_many": "يخرج المكان و{{n}} مكاناً تحته من الشجرة ومن نماذج أوامر الخدمة. يجب نقل المعدات العاملة فيها أو إزالتها أولاً.",
    "bodyBelow_other": "يخرج المكان و{{n}} مكان تحته من الشجرة ومن نماذج أوامر الخدمة. يجب نقل المعدات العاملة فيها أو إزالتها أولاً.",
    "confirm": "أرشفة المكان",
    "archived": "أُرشف {{name}}",
    "restoreTitle": "استعادة {{name}}؟",
    "restoreBody": "يعود المكان إلى الشجرة مع الأماكن التي أُرشفت معه.",
    "restoreConfirm": "استعادة المكان",
    "restored": "استُعيد {{name}}"
  },
  "generate": {
    "title": "إنشاء أماكن",
    "body": "أنشئ أماكن كثيرة دفعة واحدة: أماكن بأسمائها ونطاقاً مرقّماً، ولكل منها أماكنه الداخلية.",
    "under": "ضمن",
    "topLevel": "المستوى الأعلى من الموقع",
    "making": "تُنشأ بوصفها: {{level}}",
    "names": "أماكن بأسمائها",
    "namesHint": "اكتب الاسم واضغط Enter: ‏B1 أو G أو الميزانين أو السطح.",
    "range": "نطاق مرقّم",
    "from": "من",
    "to": "إلى",
    "prefix": "قبل الرقم",
    "suffix": "بعد الرقم",
    "pad": "عدد الخانات",
    "padOption": "{{example}}",
    "rangeExample": "يُنشئ",
    "childrenOf": "أضف في كل منها أماكن المستوى التالي ({{level}})",
    "childrenPlain": "أضف في كل منها أماكن المستوى التالي",
    "noDeeper": "لا مستوى في القالب تحت هذه الأماكن.",
    "count": "العدد",
    "pattern": "نمط الاسم",
    "patternHint": "‏{parent} اسم المكان الذي تقع فيه، و{n} الرقم: 12 و4 تصبح 1204.",
    "limits": "بحد أقصى {{step}} مكان في الدفعة الواحدة، و{{site}} مكان في الموقع.",
    "preview": "معاينة",
    "previewing": "جارٍ إعداد المعاينة",
    "newCount_zero": "مكان جديد",
    "newCount_one": "مكان جديد",
    "newCount_two": "مكان جديد",
    "newCount_few": "أماكن جديدة",
    "newCount_many": "مكاناً جديداً",
    "newCount_other": "مكان جديد",
    "existingCount_zero": "لا شيء موجود مسبقاً",
    "existingCount_one": "مكان واحد موجود مسبقاً",
    "existingCount_two": "مكانان موجودان مسبقاً",
    "existingCount_few": "{{n}} أماكن موجودة مسبقاً",
    "existingCount_many": "{{n}} مكاناً موجوداً مسبقاً",
    "existingCount_other": "{{n}} مكان موجود مسبقاً",
    "exists": "موجود مسبقاً",
    "firstNames": "الأماكن الأولى",
    "more_zero": "ولا غيرها",
    "more_one": "ومكان آخر",
    "more_two": "ومكانان آخران",
    "more_few": "و{{n}} أماكن أخرى",
    "more_many": "و{{n}} مكاناً آخر",
    "more_other": "و{{n}} مكان آخر",
    "tooMany": "‏{{n}} مكان أكثر مما تنشئه الدفعة الواحدة ({{max}}). أنشئ الطوابق على أجزاء.",
    "apply_zero": "إنشاء الأماكن",
    "apply_one": "إنشاء مكان واحد",
    "apply_two": "إنشاء مكانين",
    "apply_few": "إنشاء {{n}} أماكن",
    "apply_many": "إنشاء {{n}} مكاناً",
    "apply_other": "إنشاء {{n}} مكان",
    "applyShort": "إنشاء الأماكن",
    "done_zero": "لم يُنشأ أي مكان",
    "done_one": "أُنشئ مكان واحد",
    "done_two": "أُنشئ مكانان",
    "done_few": "أُنشئت {{n}} أماكن",
    "done_many": "أُنشئ {{n}} مكاناً",
    "done_other": "أُنشئ {{n}} مكان",
    "chips": {
      "remove": "إزالة {{value}}",
      "added_zero": "أُضيف {{value}}.",
      "added_one": "أُضيف {{value}}. اسم واحد.",
      "added_two": "أُضيف {{value}}. اسمان.",
      "added_few": "أُضيف {{value}}. {{n}} أسماء.",
      "added_many": "أُضيف {{value}}. {{n}} اسماً.",
      "added_other": "أُضيف {{value}}. {{n}} اسم.",
      "removed_zero": "أُزيل {{value}}. لا أسماء.",
      "removed_one": "أُزيل {{value}}. اسم واحد.",
      "removed_two": "أُزيل {{value}}. اسمان.",
      "removed_few": "أُزيل {{value}}. {{n}} أسماء.",
      "removed_many": "أُزيل {{value}}. {{n}} اسماً.",
      "removed_other": "أُزيل {{value}}. {{n}} اسم.",
      "invalid": "الاسم حتى 80 حرفاً",
      "limit": "حتى {{n}} اسم. أزل اسماً لإضافة غيره.",
      "notAdded_zero": "أُضيفت كل الأسماء.",
      "notAdded_one": "لم يُضف اسم واحد: الحد {{max}}.",
      "notAdded_two": "لم يُضف اسمان: الحد {{max}}.",
      "notAdded_few": "لم تُضف {{n}} أسماء: الحد {{max}}.",
      "notAdded_many": "لم يُضف {{n}} اسماً: الحد {{max}}.",
      "notAdded_other": "لم يُضف {{n}} اسم: الحد {{max}}."
    },
    "errors": {
      "nothing": "سمِّ الأماكن أو حدد نطاقاً مرقّماً.",
      "range": "راجع النطاق: أرقام صحيحة، والنهاية عند البداية أو بعدها.",
      "children": "راجع الأماكن الداخلية: العدد (من 1 إلى 200) ونمط الاسم.",
      "check": "راجع النموذج.",
      "from": "عدد صحيح من -20 إلى 500.",
      "to": "عدد صحيح حتى 500، لا يسبق «من»."
    },
    "namesPlaceholder": "B1، G، Roof"
  },
  "duplicate": {
    "title": "تكرار {{place}}",
    "body": "وحدات المبنى متشابهة في الغالب: جهّز واحدة ثم كرّرها. تُنسخ المعدات بنوعها وعلامتها التجارية وطرازها وموضعها وبياناتها، ولكل منها رمز تعريفي جديد؛ ولا تُنسخ الأرقام التسلسلية والتواريخ والملاحظات والسكان.",
    "to": "تُنشأ النسخ بوصفها",
    "toNew": "أماكن جديدة بجانبه",
    "toNewHint": "سمِّها واحداً واحداً أو رقّمها: من فيلا 2 إلى فيلا 30.",
    "toExisting": "أماكن موجودة",
    "toExistingHint": "يُنسخ ترتيبه إلى كل منها. ما هو موجود فيها يبقى ولا يتكرر.",
    "toExistingNone": "لا مكان آخر في هذا المستوى بعد.",
    "names": "نسخ بأسمائها",
    "namesHint": "اكتب الاسم واضغط Enter.",
    "targets": "الأماكن المنسوخ إليها",
    "selectShown_zero": "لا أماكن ظاهرة",
    "selectShown_one": "تحديد المكان الظاهر",
    "selectShown_two": "تحديد المكانين الظاهرين",
    "selectShown_few": "تحديد {{n}} أماكن ظاهرة",
    "selectShown_many": "تحديد {{n}} مكاناً ظاهراً",
    "selectShown_other": "تحديد {{n}} مكان ظاهر",
    "clear": "مسح التحديد",
    "chosen_zero": "لم يُحدَّد شيء",
    "chosen_one": "مكان واحد محدد",
    "chosen_two": "مكانان محددان",
    "chosen_few": "{{n}} أماكن محددة",
    "chosen_many": "{{n}} مكاناً محدداً",
    "chosen_other": "{{n}} مكان محدد",
    "noneShown": "لا يطابق البحثَ أيُّ مكان.",
    "targetAssets_zero": "لا معدات",
    "targetAssets_one": "معدّة واحدة",
    "targetAssets_two": "معدّتان",
    "targetAssets_few": "{{n}} معدّات",
    "targetAssets_many": "{{n}} معدّة",
    "targetAssets_other": "{{n}} معدّة",
    "what": "ما يُنسخ",
    "withPlaces_zero": "لا أماكن داخله",
    "withPlaces_one": "المكان الواحد داخله",
    "withPlaces_two": "المكانان داخله",
    "withPlaces_few": "الأماكن {{n}} داخله",
    "withPlaces_many": "الأماكن الـ{{n}} داخله",
    "withPlaces_other": "الأماكن الـ{{n}} داخله",
    "nothingInside": "لا شيء داخله بعد: كل نسخة هي المكان وحده مع معداته.",
    "withAssets": "معداته العاملة",
    "withAssetsHint": "المكان الذي فيه معدات يحتفظ بها ولا تُنسخ إليه معدات.",
    "renumber": "إعادة تسمية الأماكن الداخلية لتتبع كل نسخة",
    "renumberExample": "‏{{from}} يصبح {{to}}",
    "limits": "بحد أقصى {{places}} مكان و{{assets}} معدّة في الدفعة الواحدة.",
    "assetsCount_zero": "لا معدات تُضاف",
    "assetsCount_one": "معدّة واحدة تُضاف",
    "assetsCount_two": "معدّتان تُضافان",
    "assetsCount_few": "{{n}} معدّات تُضاف",
    "assetsCount_many": "{{n}} معدّة تُضاف",
    "assetsCount_other": "{{n}} معدّة تُضاف",
    "skipped_zero": "لا أماكن تحتفظ بمعداتها",
    "skipped_one": "مكان واحد يحتفظ بمعداته",
    "skipped_two": "مكانان يحتفظان بمعداتهما",
    "skipped_few": "{{n}} أماكن تحتفظ بمعداتها",
    "skipped_many": "{{n}} مكاناً يحتفظ بمعداته",
    "skipped_other": "{{n}} مكان يحتفظ بمعداته",
    "nothing": "كل شيء موجود مسبقاً: لا شيء يُضاف.",
    "submit": "تكرار",
    "done": "تم تكرار {{place}}",
    "errors": {
      "names": "سمِّ النسخ أو حدد نطاقاً مرقّماً.",
      "targets": "اختر الأماكن المنسوخ إليها."
    }
  },
  "import": {
    "title": "استيراد الأماكن والمعدات",
    "body": "أماكن هذا الموقع ومعداته من جدول: تُنشأ الأماكن الناقصة، والسطر الذي يحمل رمزاً تعريفياً موجوداً يحدّث تلك المعدّة، ولا يُحذف شيء.",
    "templateStep": "1. احصل على القالب",
    "typesHint": "في القالب عمود لكل بيان من بيانات الأنواع المحددة.",
    "noTypes": "لا أنواع معدات بعد: أضفها من الإعدادات › أنواع المعدات.",
    "template": "تنزيل القالب",
    "columns": "الأعمدة:",
    "placeRule": "المكان: المسار من الأعلى مع « / » أو « › » بين المستويات، مثل «12 / 1204». تركه فارغاً يضع المعدّة على الموقع نفسه.",
    "positionRule": "الموضع (اختياري): مكان الوحدة داخل المكان، مثل «غرفة النوم 2».",
    "tagRule": "الرمز التعريفي: تركه فارغاً يعطيها الرمز التالي لنوعها، والرمز الموجود يحدّث تلك المعدّة.",
    "limit": "حتى {{n}} سطر في الملف. احفظه من Excel بصيغة «CSV UTF-8».",
    "fileStep": "2. أرسل الملف",
    "file": "ملف CSV",
    "choose": "اختيار ملف CSV",
    "chooseAnother": "اختيار ملف آخر",
    "sending": "جارٍ إرسال الملف…",
    "previewing": "جارٍ قراءة الأسطر…",
    "previewStep": "3. راجع ثم طبّق",
    "summary": "ما سيفعله الاستيراد",
    "count": {
      "create": "معدات جديدة",
      "update": "تُحدَّث",
      "unchanged": "بلا تغيير",
      "newPlaces": "أماكن جديدة",
      "error": "أسطر فيها أخطاء"
    },
    "fileErrors": "لا يمكن قراءة الملف كما هو",
    "errorsTitle_zero": "لا أخطاء في الأسطر",
    "errorsTitle_one": "سطر واحد فيه أخطاء",
    "errorsTitle_two": "سطران فيهما أخطاء",
    "errorsTitle_few": "{{n}} أسطر فيها أخطاء",
    "errorsTitle_many": "{{n}} سطراً فيها أخطاء",
    "errorsTitle_other": "{{n}} سطر فيها أخطاء",
    "errorsBody": "صحّحها في الجدول ثم اختر الملف من جديد. لا يُستورد شيء ما دام في سطر خطأ.",
    "errorsTable": "الأخطاء حسب السطر",
    "line": "السطر",
    "column": "العمود",
    "problem": "المشكلة",
    "nothing": "لا شيء يتغير: كل الأسطر مطابقة لما هو مسجل.",
    "ready_zero": "لا شيء للإضافة أو التحديث.",
    "ready_one": "جاهز: معدّة واحدة للإضافة أو التحديث.",
    "ready_two": "جاهز: معدّتان للإضافة أو التحديث.",
    "ready_few": "جاهز: {{n}} معدّات للإضافة أو التحديث.",
    "ready_many": "جاهز: {{n}} معدّة للإضافة أو التحديث.",
    "ready_other": "جاهز: {{n}} معدّة للإضافة أو التحديث.",
    "readyWithPlaces_zero": "جاهز: أماكن جديدة عددها {{places}}.",
    "readyWithPlaces_one": "جاهز: معدّة واحدة للإضافة أو التحديث، وأماكن جديدة عددها {{places}}.",
    "readyWithPlaces_two": "جاهز: معدّتان للإضافة أو التحديث، وأماكن جديدة عددها {{places}}.",
    "readyWithPlaces_few": "جاهز: {{n}} معدّات للإضافة أو التحديث، وأماكن جديدة عددها {{places}}.",
    "readyWithPlaces_many": "جاهز: {{n}} معدّة للإضافة أو التحديث، وأماكن جديدة عددها {{places}}.",
    "readyWithPlaces_other": "جاهز: {{n}} معدّة للإضافة أو التحديث، وأماكن جديدة عددها {{places}}.",
    "newPlacesTitle_zero": "لا أماكن ستُنشأ",
    "newPlacesTitle_one": "مكان واحد سيُنشأ",
    "newPlacesTitle_two": "مكانان سيُنشآن",
    "newPlacesTitle_few": "{{n}} أماكن ستُنشأ",
    "newPlacesTitle_many": "{{n}} مكاناً سيُنشأ",
    "newPlacesTitle_other": "{{n}} مكان سيُنشأ",
    "staleTitle": "تغيّر الملف أو الموقع منذ المعاينة",
    "staleBody": "غيّر أحدهم أماكن هذا الموقع أو معداته، أو تغيّر الملف، بعد المعاينة. عاين من جديد لترى ما سيفعله الاستيراد الآن.",
    "previewAgain": "المعاينة من جديد",
    "apply_zero": "استيراد",
    "apply_one": "استيراد معدّة واحدة",
    "apply_two": "استيراد معدّتين",
    "apply_few": "استيراد {{n}} معدّات",
    "apply_many": "استيراد {{n}} معدّة",
    "apply_other": "استيراد {{n}} معدّة",
    "applyShort": "استيراد",
    "applied_zero": "لم تُستورد أي معدّة",
    "applied_one": "استُوردت معدّة واحدة",
    "applied_two": "استُوردت معدّتان",
    "applied_few": "استُوردت {{n}} معدّات",
    "applied_many": "استُوردت {{n}} معدّة",
    "applied_other": "استُوردت {{n}} معدّة",
    "previewDone": "المعاينة جاهزة: {{create}} للإضافة، {{update}} للتحديث، {{error}} بها أخطاء.",
    "fromAssistant": {
      "title": "قرأه المساعد",
      "body": "كتب المساعد ما قرأه في هذا الملف. راجع المعاينة قبل تطبيقها؛ تتحقق قواعد الاستيراد من كل صف.",
      "truncated": "في المستند معدات أكثر مما تتسع له قراءة واحدة؛ هنا الصفوف الأولى فقط. اقرأ الباقي على حدة.",
      "notes": "ملاحظات المساعد"
    }
  },
  "form": {
    "code": "الرمز",
    "codeHint": "قصير، للاستيراد والملصقات.",
    "template": "قالب الموقع",
    "noTemplate": "بلا قالب",
    "templateNone": "بلا قالب تُسمّى الأماكن «أماكن» فقط.",
    "templateFlat": "بلا مستويات: المعدات على الموقع نفسه.",
    "governorate": "المحافظة",
    "noGovernorate": "بلا محافظة",
    "wilayat": "الولاية",
    "noWilayat": "بلا ولاية",
    "wilayatHint": "اختر المحافظة أولاً.",
    "areaHint": "الحي: الخوير، بوشر.",
    "mapPoint": "الموقع على الخريطة",
    "mapPointHint": "رابط خريطة، أو خط العرض وخط الطول (كلاهما).",
    "latitude": "خط العرض",
    "longitude": "خط الطول",
    "errors": {
      "governorate": "اختر محافظة من القائمة",
      "governorateFirst": "اختر المحافظة أولاً",
      "wilayat": "هذه الولاية ليست في المحافظة المختارة",
      "bothCoordinates": "أدخل خط العرض وخط الطول معاً، أو اتركهما فارغين",
      "latitude": "خط العرض بين ‎-90 و90",
      "longitude": "خط الطول بين ‎-180 و180",
      "coordinate": "استخدم رقماً مثل 23.5880",
      "code": "أحرف وأرقام ونقطة وشرطة وشرطة سفلية",
      "codeTaken": "هذا الرمز مستخدم لموقع آخر",
      "archived": "أُرشف هذا الموقع في أثناء ذلك: استعده لتعديله.",
      "customerInactive": "هذا العميل غير نشط: اختر عميلاً نشطاً."
    },
    "conflict": "حفظ شخص آخر هذا الموقع في أثناء تعديلك. بقي ما كتبته: راجعه واحفظ مرة أخرى."
  },
  "register": {
    "title": "المواقع والمعدات",
    "count_zero": "لا مواقع",
    "count_one": "موقع واحد",
    "count_two": "موقعان",
    "count_few": "{{n}} مواقع",
    "count_many": "{{n}} موقعاً",
    "count_other": "{{n}} موقع",
    "search": "البحث بالموقع أو الرمز أو العميل",
    "columns": {
      "site": "الموقع",
      "customer": "العميل",
      "template": "القالب",
      "places": "الأماكن",
      "assets": "المعدات",
      "issues": "معطّلة"
    },
    "views": "طرق عرض السجل",
    "sitesTab": "المواقع",
    "assetsTab": "المعدات",
    "empty": "لا مواقع بعد",
    "emptyBody": "أضف أول موقع من هنا، أو من تبويب الخدمة في ملف العميل، أو مع أمر خدمة جديد.",
    "noMatches": "لا يطابق البحثَ أيُّ موقع.",
    "noMatchesBody": "تبحث عن رمز تعريفي لمعدّة؟ استخدم «البحث عن معدّة برمزها التعريفي» أعلاه.",
    "clearSearch": "مسح البحث",
    "newJob": "أمر خدمة جديد",
    "openCustomers": "فتح العملاء"
  },
  "newSite": {
    "action": "موقع جديد",
    "title": "موقع جديد",
    "submit": "إضافة الموقع",
    "added": "أُضيف الموقع {{name}}",
    "chooseCustomer": "اختر العميل"
  },
  "assets": {
    "label": "معدات كل المواقع",
    "search": "الرمز أو الرقم التسلسلي أو الموقع أو العميل",
    "status": "الحالة",
    "current": "في الخدمة أو معطّلة",
    "type": "نوع المعدّة",
    "anyType": "كل الأنواع",
    "empty": "لا معدات بعد",
    "emptyBody": "تُضاف المعدات من صفحة الموقع، واحدة تلو الأخرى أو من ملف CSV.",
    "noMatches": "لا تطابق أيُّ معدّة.",
    "noMatchesBody": "غيّر البحث أو عوامل التصفية.",
    "clear": "مسح البحث وعوامل التصفية"
  },
  "templates": {
    "addPresets": "إضافة القوالب القياسية",
    "new": "قالب جديد",
    "views": "القوالب",
    "active": "النشطة",
    "archived": "المؤرشفة",
    "listLabel": "قوالب المواقع",
    "archivedStamp": "مؤرشف",
    "flat": "بلا مستويات",
    "siteCount_zero": "لا مواقع",
    "siteCount_one": "موقع واحد",
    "siteCount_two": "موقعان",
    "siteCount_few": "{{n}} مواقع",
    "siteCount_many": "{{n}} موقعاً",
    "siteCount_other": "{{n}} موقع",
    "edit": "تعديل {{name}}",
    "archive": "أرشفة {{name}}",
    "restore": "استعادة {{name}}",
    "empty": "لا قوالب مواقع بعد",
    "emptyBody": "ابدأ بالقوالب القياسية: برج سكني، مبنى مكاتب، فندق، مجمع تجاري، مجمع فلل، مصنع، فيلا أو محل.",
    "emptyArchived": "لا قوالب مؤرشفة.",
    "presetsAdded_zero": "لم يُضف أي قالب",
    "presetsAdded_one": "أُضيف قالب واحد",
    "presetsAdded_two": "أُضيف قالبان",
    "presetsAdded_few": "أُضيفت {{n}} قوالب",
    "presetsAdded_many": "أُضيف {{n}} قالباً",
    "presetsAdded_other": "أُضيف {{n}} قالب",
    "presetsNone": "القوالب القياسية موجودة مسبقاً",
    "newTitle": "قالب موقع جديد",
    "editTitle": "تعديل القالب {{code}}",
    "fields": {
      "code": "الرمز",
      "name": "الاسم",
      "nameAr": "الاسم بالعربية"
    },
    "levels": "المستويات",
    "levelsHint": "من الأعلى: الطابق ثم الشقة. بلا مستويات تكون المعدات على الموقع نفسه.",
    "inUse_zero": "لا يستخدم هذا القالبَ أيُّ موقع.",
    "inUse_one": "يستخدم هذا القالبَ موقعٌ واحد: يمكن تغيير أسماء المستويات، ويبقى عددها كما هو.",
    "inUse_two": "يستخدم هذا القالبَ موقعان: يمكن تغيير أسماء المستويات، ويبقى عددها كما هو.",
    "inUse_few": "يستخدم هذا القالبَ {{n}} مواقع: يمكن تغيير أسماء المستويات، ويبقى عددها كما هو.",
    "inUse_many": "يستخدم هذا القالبَ {{n}} موقعاً: يمكن تغيير أسماء المستويات، ويبقى عددها كما هو.",
    "inUse_other": "يستخدم هذا القالبَ {{n}} موقع: يمكن تغيير أسماء المستويات، ويبقى عددها كما هو.",
    "noLevels": "بلا مستويات: فيلا أو محل، ومعداته على الموقع نفسه.",
    "levelRow": "المستوى {{n}}",
    "levelEn": "الاسم بالإنجليزية",
    "levelAr": "الاسم بالعربية",
    "up": "تحريك المستوى {{n}} لأعلى",
    "down": "تحريك المستوى {{n}} لأسفل",
    "remove": "إزالة المستوى {{n}}",
    "addLevel": "إضافة مستوى",
    "maxLevels": "حتى {{n}} مستويات.",
    "save": "حفظ القالب",
    "saved": "حُفظ القالب {{name}}",
    "archiveTitle": "أرشفة {{name}}؟",
    "archiveBody": "لن تتمكن المواقع الجديدة من اختياره، وتحتفظ المواقع التي تستخدمه بأماكنها وأسماء مستوياتها.",
    "archiveConfirm": "أرشفة القالب",
    "restoreTitle": "استعادة {{name}}؟",
    "restoreBody": "يمكن للمواقع الجديدة اختياره من جديد.",
    "restoreConfirm": "استعادة القالب",
    "toastArchived": "أُرشف {{name}}",
    "toastRestored": "استُعيد {{name}}",
    "errors": {
      "code": "استخدم أحرفاً أو أرقاماً أو نقطة أو شرطة أو شرطة سفلية (حتى 20)",
      "codeTaken": "هذا الرمز مستخدم لقالب آخر",
      "name": "أدخل اسم القالب",
      "level": "سمِّ المستوى بالإنجليزية والعربية"
    }
  },
  "types": {
    "addPresets": "إضافة الأنواع القياسية…",
    "new": "نوع جديد",
    "views": "أنواع المعدات",
    "active": "النشطة",
    "archived": "المؤرشفة",
    "listLabel": "أنواع المعدات",
    "archivedStamp": "مؤرشف",
    "tagExample": "الرموز التعريفية {{tag}}",
    "fieldCount_zero": "لا بيانات",
    "fieldCount_one": "بيان واحد",
    "fieldCount_two": "بيانان",
    "fieldCount_few": "{{n}} بيانات",
    "fieldCount_many": "{{n}} بياناً",
    "fieldCount_other": "{{n}} بيان",
    "checkCount_zero": "لا فحوص",
    "checkCount_one": "فحص واحد",
    "checkCount_two": "فحصان",
    "checkCount_few": "{{n}} فحوص",
    "checkCount_many": "{{n}} فحصاً",
    "checkCount_other": "{{n}} فحص",
    "every_zero": "بلا فترة صيانة",
    "every_one": "صيانة كل شهر",
    "every_two": "صيانة كل شهرين",
    "every_few": "صيانة كل {{n}} أشهر",
    "every_many": "صيانة كل {{n}} شهراً",
    "every_other": "صيانة كل {{n}} شهر",
    "assetCount_zero": "لا معدات",
    "assetCount_one": "معدّة واحدة",
    "assetCount_two": "معدّتان",
    "assetCount_few": "{{n}} معدّات",
    "assetCount_many": "{{n}} معدّة",
    "assetCount_other": "{{n}} معدّة",
    "edit": "تعديل {{name}}",
    "archive": "أرشفة {{name}}",
    "restore": "استعادة {{name}}",
    "empty": "لا أنواع معدات بعد",
    "emptyBody": "ابدأ بالأنواع القياسية لمجالك: التكييف، المصاعد، السلامة من الحريق، المولدات، المضخات، مكافحة الآفات، كاميرات المراقبة.",
    "emptyArchived": "لا أنواع مؤرشفة.",
    "presetsTitle": "إضافة أنواع المعدات القياسية",
    "presetsBody": "تُضاف أنواع المجالات المحددة ببياناتها وقوائم فحصها، وتبقى الأنواع الموجودة لدى الشركة كما هي.",
    "industries": "المجالات",
    "presetsApply": "إضافة الأنواع",
    "presetsAdded_zero": "لم يُضف أي نوع",
    "presetsAdded_one": "أُضيف نوع واحد",
    "presetsAdded_two": "أُضيف نوعان",
    "presetsAdded_few": "أُضيفت {{n}} أنواع",
    "presetsAdded_many": "أُضيف {{n}} نوعاً",
    "presetsAdded_other": "أُضيف {{n}} نوع",
    "presetsNone": "هذه الأنواع موجودة مسبقاً",
    "industry": {
      "HVAC": {
        "label": "التكييف (HVAC)",
        "body": "المكيفات المنفصلة والمركزية بالمجاري والوحدات المجمعة والمبردات ووحدات ملف المروحة ومناولة الهواء."
      },
      "LIFTS": {
        "label": "المصاعد",
        "body": "مصاعد الركاب والبضائع."
      },
      "FIRE": {
        "label": "السلامة من الحريق",
        "body": "طفايات الحريق ولوحات إنذار الحريق."
      },
      "POWER": {
        "label": "الطاقة",
        "body": "المولدات الاحتياطية."
      },
      "PLUMBING": {
        "label": "السباكة",
        "body": "مضخات المياه وسخانات المياه."
      },
      "PEST": {
        "label": "مكافحة الآفات",
        "body": "محطات الطُّعم."
      },
      "SECURITY": {
        "label": "الأمن",
        "body": "كاميرات المراقبة."
      }
    },
    "newTitle": "نوع معدّة جديد",
    "editTitle": "تعديل النوع {{code}}",
    "fields": {
      "code": "الرمز",
      "name": "الاسم",
      "nameAr": "الاسم بالعربية",
      "tagPrefix": "بادئة الرمز التعريفي",
      "interval": "فترة الصيانة (بالأشهر)"
    },
    "tagHint": "المعدّة الجديدة بلا رمز تعريفي تأخذ الرمز التالي: {{tag}}.",
    "intervalHint": "كم مرة تُصان عادةً؛ تبدأ منها خطط الصيانة.",
    "fieldsTitle": "البيانات",
    "fieldsHint": "ما يُسجَّل لكل معدّة من هذا النوع: القدرة، غاز التبريد، الحجم.",
    "noFields": "بلا بيانات: تُسجَّل للمعدات العلامة التجارية والطراز والرقم التسلسلي فقط.",
    "fieldRow": "البيان {{n}}",
    "field": {
      "en": "التسمية بالإنجليزية",
      "ar": "التسمية بالعربية",
      "key": "عمود الاستيراد",
      "kind": "النوع",
      "unit": "الوحدة",
      "required": "مطلوب"
    },
    "kind": {
      "text": "نص",
      "number": "رقم",
      "select": "اختيار",
      "date": "تاريخ",
      "boolean": "نعم أو لا"
    },
    "options": "الخيارات",
    "optionsHint": "اكتب القيمة؛ التسمية المتروكة فارغة تُقرأ كالقيمة.",
    "option": {
      "value": "القيمة",
      "en": "التسمية بالإنجليزية (اختيارية)",
      "ar": "التسمية بالعربية (اختيارية)"
    },
    "addOption": "إضافة خيار",
    "removeOption": "إزالة الخيار {{name}}",
    "addField": "إضافة بيان",
    "checklistTitle": "قائمة الفحص",
    "checklistHint": "ما يفحصه الفني أو يقرؤه في كل معدّة من هذا النوع خلال الزيارة.",
    "noChecks": "لا فحوص بعد.",
    "checkRow": "الفحص {{n}}",
    "check": {
      "en": "الفحص بالإنجليزية",
      "ar": "الفحص بالعربية",
      "kind": "النوع"
    },
    "checkKind": {
      "check": "تم أو لم يتم",
      "reading": "قراءة"
    },
    "addCheck": "إضافة فحص",
    "up": "تحريك {{name}} لأعلى",
    "down": "تحريك {{name}} لأسفل",
    "removeRow": "إزالة {{name}}",
    "save": "حفظ النوع",
    "saved": "حُفظ النوع {{name}}",
    "archiveTitle": "أرشفة {{name}}؟",
    "archiveBody": "لا يمكن أن تكون المعدات الجديدة من هذا النوع، وتحتفظ معداته الحالية به.",
    "archiveConfirm": "أرشفة النوع",
    "restoreTitle": "استعادة {{name}}؟",
    "restoreBody": "يمكن أن تكون المعدات الجديدة من هذا النوع من جديد.",
    "restoreConfirm": "استعادة النوع",
    "toastArchived": "أُرشف {{name}}",
    "toastRestored": "استُعيد {{name}}",
    "errors": {
      "code": "استخدم أحرفاً أو أرقاماً أو نقطة أو شرطة أو شرطة سفلية (حتى 20)",
      "codeTaken": "هذا الرمز مستخدم لنوع آخر",
      "name": "أدخل اسم النوع",
      "tagPrefix": "من حرفين إلى ستة أحرف لاتينية كبيرة",
      "interval": "عدد صحيح من الأشهر، من 1 إلى 60",
      "key": "أحرف لاتينية صغيرة وأرقام وشرطات سفلية، ويبدأ بحرف",
      "label": "اكتب التسمية بالإنجليزية والعربية",
      "options": "حقل الاختيار يحتاج إلى خياراته",
      "option": "أعطِ كل خيار قيمته",
      "unit": "حتى 20 حرفاً",
      "row": "راجع هذا السطر",
      "keysTwice": "سطران بالمفتاح نفسه: لكل سطر مفتاحه"
    },
    "keyHint": "عمود الاستيراد: يُملأ من التسمية الإنجليزية. تغييره يغيّر اسم العمود في ملفات الاستيراد."
  },
  "errors": {
    "CODE_TAKEN": "هذا الرمز مستخدم.",
    "TAG_TAKEN": "هذا الرمز التعريفي مستخدم لمعدّة أخرى.",
    "PLACE_TOO_DEEP": "هذا أعمق مما تسمح به مستويات الموقع.",
    "SITE_LIMIT": "عدد الأماكن أكبر مما يسمح به الموقع أو الدفعة الواحدة.",
    "PLACE_NAME_TAKEN": "يوجد مكان بجانبه بهذا الاسم.",
    "PLACE_CYCLE": "لا يمكن نقل المكان تحت نفسه أو تحت أحد أماكنه.",
    "NOT_OF_SITE": "هذا المكان أو هذه المعدّة تابعة لموقع آخر.",
    "PLACE_HAS_ASSETS": "لا تزال فيه معدات عاملة: انقلها أو أزلها أولاً.",
    "ASSET_FINAL": "المعدّة المستبدلة أو المزالة لا تتغير.",
    "TEMPLATE_IN_USE": "تستخدم مواقعُ هذا القالب: يبقى عدد مستوياته كما هو.",
    "IMPORT_STALE": "تغيّر الملف أو الموقع منذ المعاينة. عاين من جديد.",
    "ASSETS_OFF": "سجل المعدات متوقف في إعدادات الخدمة.",
    "SITE_UNDER_CONTRACT": "يغطي هذا الموقعَ عقدُ صيانة ساري: افسخه أو أخرج الموقع منه قبل أرشفة الموقع."
  },
  "capture": {
    "title": "تعبئة من قائمة أو مستند",
    "description": "يقرأ المساعد المعدات في قائمة مكتوبة، أو في صور أو ملف PDF (جدول تسليم، أو ملحق عقد، أو مسح للموقع)، ويفتح معاينة الاستيراد. تراجعها وتطبّقها؛ لا يُضاف شيء هنا.",
    "prompt": "اقرأ المعدات في هذه القائمة أو هذا المستند لهذا الموقع.",
    "read": "قراءة",
    "needsInput": "اكتب قائمة، أو أضف صورة أو ملف PDF لها، أولًا.",
    "list": {
      "label": "قائمة المعدات",
      "hint": "مكان كل قطعة ونوعها وما هو مكتوب عنها: العلامة التجارية والطراز والرقم التسلسلي والسعة.",
      "placeholder": "فيلا 1 / المطبخ: مكيف سبليت، Gree، 18000 وحدة حرارية\nفيلا 1 / غرفة النوم 1: 2 × مكيف سبليت، Gree"
    },
    "drop": {
      "title": "أفلت صور القائمة أو ملف PDF لها هنا",
      "titleTouch": "صورة القائمة أو ملف PDF لها"
    },
    "refused": {
      "size": "حجمه أكبر من {{limit}} حتى بعد تصغيره. صوّر القائمة صفحةً صفحة، أو احفظ ملف PDF أصغر."
    },
    "privacy": {
      "short": "لا يُحتفظ بالمستند؛ ويبقى ما تكتبه في سجل المساعد لديك طوال مدة الاحتفاظ التي تحددها شركتك.",
      "sent": "ما تكتبه والمستند كاملًا يُرسَلان إلى OpenAI عبر مفتاح شركتك، بكل ما هو مكتوب عليه: أسماء الشاغلين وهواتفهم أيضًا.",
      "kept": "لا يحتفظ المساعد بالمستند. أما ما تكتبه فيُحفظ رسالةً منك في سجل المساعد، ويُحذف وفق قاعدة الاحتفاظ في شركتك.",
      "attached": "ما يبقى هو الملف الذي يكتبه المساعد منه: يُرفق بالموقع عند فتح معاينة الاستيراد، كأي ملف مستورد."
    },
    "progress": {
      "types": "جارٍ قراءة أنواع الأصول…",
      "places": "جارٍ قراءة أماكن الموقع…"
    },
    "errors": {
      "budget": "استُنفد رصيد المساعد الذكي لشركتك هذا الشهر. استورد ملف CSV بدلًا من ذلك، أو اطلب من المسؤول رفعه في الإعدادات › المساعد الذكي.",
      "dailyLimit": "استنفدت تشغيلات المساعد المتاحة لك اليوم. استورد ملف CSV بدلًا من ذلك، أو اقرأه غدًا.",
      "AI_DOCUMENT_TOO_LONG": "في ملف PDF هذا {{pages}} صفحة، والحد الأقصى {{max}}. أرسل صفحاته على أجزاء.",
      "AI_DOCUMENT_TOO_LONG_unknown": "صفحات ملف PDF هذا أكثر من الحد الأقصى ({{max}}). أرسل صفحاته على أجزاء."
    },
    "nothing": {
      "title": "تعذّرت قراءة أي معدات",
      "body": "جرّب صورة أوضح تظهر فيها القائمة كاملة، أو اكتب القائمة."
    },
    "tryAgain": "إعادة المحاولة",
    "notes": "ملاحظات المساعد"
  },
  "conflict": {
    "form": "حفظ شخص آخر تغييراً هنا في أثناء تعديلك. بقي ما كتبته: راجعه واحفظ مرة أخرى.",
    "action": "غيّر شخص آخر {{name}} في أثناء ذلك. أُعيد تحميله: راجعه وأكّد مرة أخرى.",
    "gone": "لم يعد {{name}} في الشجرة: أرشفه شخص آخر أو نقله.",
    "done": "سبقك شخص آخر إلى ذلك: {{name}} محدَّث."
  }
}
